import {lazy} from 'react';

export const ContactPageMapLazy = lazy(() => import(/* webpackChunkName: "contactPageMap" */ './contactPageMapFactory'));
